import sanitize from 'sanitize-html';

const sanitizeHtml = (htmlString: string, overwriteConfig = {}) => {
  const config = {
    ...overwriteConfig,
  };

  return {
    __html: sanitize(htmlString, config),
  };
};

export const removeTelephoneFromAnchor = (htmlString: string): string => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = htmlString;

  const telLinks = tempElement.querySelectorAll('a[href^="tel:"]');

  telLinks.forEach((link) => {
    const content = document.createTextNode(link.textContent);
    link.parentNode?.replaceChild(content, link);
  });

  return tempElement.innerHTML;
};

export default sanitizeHtml;
